import React from 'react';
import { BsInfoCircle } from "react-icons/bs";

const InformationModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  // console.log("entered the information modal");

  const modalContainerStyle = {
    display: 'flex',
    position: 'fixed',
    zIndex: 999999999,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    overflow: 'auto',
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const modalContentStyle = {
    backgroundColor: '#fefefe',
    margin: '15% auto',
    border: '1px solid #888',
    borderRadius: '10px',
    border: '3px solid #ee373b',
    width: '80%',
    maxWidth: '400px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
  };

  const modalHeaderStyle = {
    display: 'flex',
    backgroundColor: '#ee373b',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    padding: '5px 5px',
    minHeight: '8vh',
  };

  const modalTitleStyle = {
    margin: 0,
    color: 'white',
    fontWeight: 'bold',
    fontSize: '18px',
  };

  const closeButtonStyle = {
    padding: '5px 10px',
    border: '2px solid #ee373b',
    borderRadius: '40px',
    backgroundColor: 'white',
    color: '#ee373b',
    cursor: 'pointer',
    fontSize: '12px',
  };

  const modalBodyStyle = {
    padding: '20px 20px 20px 20px',
    color: 'black',
  };

  const modalFooterStyle = {
    textAlign: 'center',
    paddingBottom: '20px',
  };

  const footerButtonStyle = {
    padding: '5px 10px',
    border: '2px solid #ee373b',
    backgroundColor: '#ee373b',
    color: '#ffffff',
    borderRadius: '5px',
    cursor: 'pointer',
  };

  return (
    <div style={modalContainerStyle}>
      <style>{`
          .footer-button {
            padding: 5px 20px;
            border: 2px solid #ee373b;
            background-color: #ee373b;
            font-weight: bold;
            color: #ffffff;
            border-radius: 5px;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          .footer-button:hover {
            background-color: #ffffff;
            color: #ee373b;
          }
        `}</style>
      <div style={modalContentStyle}>
        <div style={modalHeaderStyle}>
          <h2 style={modalTitleStyle}>
            <BsInfoCircle color="white" strokeWidth={0.9} />
            <span style={{ marginLeft: '5px' }}>Information</span>
          </h2>
        </div>
        <div style={modalBodyStyle}>
          <p style={{ textAlign: 'center', lineHeight: '24px', fontSize: '14px', marginBottom: '0px'}}>
            {message}
          </p>
        </div>
        <div style={modalFooterStyle}>
          <button className='footer-button' onClick={onClose}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default InformationModal;
